import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiTerraform,
  SiAnsible,
  SiGithubactions,
  SiAmazonaws,
  SiMicrosoftazure,
  SiGooglecloud,
  SiPrometheus,
  SiGrafana,
  SiDocker,
  SiKubernetes,
  SiJenkins,
  SiLinux,
  SiSwagger
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons"><SiVisualstudiocode title="VS Code" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiPostman title="Postman" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiTerraform title="Terraform" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiAnsible title="Ansible" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiGithubactions title="GitHub Actions" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiAmazonaws title="AWS CLI" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiMicrosoftazure title="Azure" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiGooglecloud title="GCP" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiPrometheus title="Prometheus" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiGrafana title="Grafana" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiDocker title="Docker" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiKubernetes title="Kubernetes" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiJenkins title="Jenkins" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiLinux title="Linux" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiSwagger title="Swagger" /></Col>
    </Row>
  );
}

export default Toolstack;
